/**
 * The host a citation is shown as. Pluto cites full URLs, which read badly
 * inline, so the answer shows where a fact came from rather than the path.
 */
export const citationLabel = (href: string): string => {
  try {
    return new URL(href).hostname.replace(/^www\./, "");
  } catch {
    return href;
  }
};

/**
 * Only http(s) links become anchors, so a model-authored `javascript:` or
 * `data:` URL can never render as something the user can click.
 */
export const isCitationHref = (href: string): boolean => {
  try {
    const { protocol } = new URL(href);

    return protocol === "https:" || protocol === "http:";
  } catch {
    return false;
  }
};

/**
 * A link to a company's page in Bloodline, which the answer writes as a path
 * rather than a URL. The identifier has already been confirmed against the
 * database by the time an answer reaches the client, so what is checked here is
 * only the shape: a single path segment, so nothing can be smuggled into the
 * route, and a country-prefixed organisation number, which is how companies are
 * stored.
 */
export const companyHrefOrgnr = (href: string): string | null => {
  const match = /^\/company\/([A-Z]{2}\d{6,14})$/.exec(href);

  return match?.[1] ?? null;
};
